module.exports = __webpack_public_path__ + "static/img/30012 (2).a693571.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (2).webp
// module id = N+vC
// module chunks = 14